import { api_get, api_post } from "./utils"

// import localforage from "localforage";

const UserAPI = {
	load: _loadUser,
	loadUserRoles: _loadUserRoles,
	loadUserItems: _loadUserItems,
    supportEmailSearch: _supportEmailSearch,
    supportUserFetch: _supportUserFetch,
	doPasswordChange: _doPasswordChange,
	passwordStartUpdate: _passwordStartUpdate
};


async function _loadUser() {
	return api_get("/users/me").then((res) => {
		if(!res.ok) { // token is bad, delete it
			console.log("loadUser failed");
			// localforage.removeItem("access_token");
			return null;
		}
		else {
			return  res.json();
		}
	}).catch((err) => {
		console.log("loadUser failed");
		console.log(err);
		return null;
	});
}

async function _loadUserRoles() {
	return api_get("/users/roles").then((res) => {
		return res.json();
	})
}

async function _loadUserItems(item_type : string, cursor = "") {
	const url = "/users/items?item_type=" + item_type + ((cursor) ? '&cursor=' + cursor : '');
	return api_get(url).then((res) => {
		return res.json();
	})
}



async function _doPasswordChange(resetTokenKey: string, uuid: string, password: string) {
	const url = "/password/change";
	const data = { key: resetTokenKey,
		uuid: uuid,
		password: password };

	return api_post(url, data).then((res) => {
  return res.json();
	});

}


async function _passwordStartUpdate(email: string) {
	const url = "/password/start-reset";
	const data = { email: email };
	return api_post(url, data).then( async (res) => {
        if(res.status > 200) {
            throw await res.json();
        }
        return res.json();
	})
}


async function _supportUserFetch(identity: string, userKey: string) {
	const url = "/users/support-user-fetch";
	const data = { identity, search_user: userKey };
	return api_get(url, data).then( async (res) => {
        if(res.status > 200) {
            throw await res.json();
        }
        return res.json();
	})

}

async function _supportEmailSearch(identity: string, query: string, cursor = "") {
    const url = "/users/support-email-search"
    const params = {
        identity, query, cursor
    }
	return api_get(url, params).then((res) => {
		return res.json();
	})
}

export default UserAPI;
